import { FormTextarea } from '@shared/components';

export interface BlockedReasonFieldProps {
  name: string;
}

export default function BlockedReasonField(props: Readonly<BlockedReasonFieldProps>) {
  return (
    <FormTextarea
      {...props}
      label='หมายเหตุเพิ่มเติม'
      placeholder='ระบุความคิดเห็นเพิ่มเติม'
      sx={{ maxWidth: '600px' }}
    />
  );
}
